import { render, staticRenderFns } from "./dynamic-pages.vue?vue&type=template&id=ab323b06&scoped=true&"
import script from "./dynamic-pages.vue?vue&type=script&lang=js&"
export * from "./dynamic-pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab323b06",
  null
  
)

export default component.exports